import React from 'react';
import Nav from './components/Nav';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Sectors from './components/Sectors';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Nav />
      <Hero />
      <About />
      <Services />
      <Sectors />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
